import FormGroup from '../FormGroup';
import classNames from 'classnames/bind';
import styles from './Form.module.scss';

const cx = classNames.bind(styles);

// title
// introduce
// content
// author_id
// type_id

function TipTypeForm({ keyForm, titleBtn = 'Submit', data = {}, types = [], handleSubmit = () => {}, fileInputRef }) {
  return (
    <form className={cx('create-post')} key={keyForm} encType="multipart/form-data" onSubmit={handleSubmit}>
      <FormGroup title="Name" name="name" value={data?.name} placeholder="Name" />
      <button type="submit">{titleBtn}</button>
    </form>
  );
}

export default TipTypeForm;
